import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type RejectCampaignResponse = {
    result: string;
}

type UseRejectCampaignResponse = [
    (data: CampaignObject) => Promise<RejectCampaignResponse | null>,
    {
        value?: RejectCampaignResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useRejectCampaign = (): UseRejectCampaignResponse => {
    
    const [post, postState] = usePost<RejectCampaignResponse, CampaignObject>({
        url: `campaign/reject-campaign`
    })

    const rejectCampaign = async (
        data : CampaignObject
    ) : Promise<RejectCampaignResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [rejectCampaign, postState];
};